import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserRoleService {
  baseUrl: string = '/auth/api/';

  constructor(private http: HttpClient) {}

  /** Staff Users*/
  getStaffUsers(filter: any): Observable<any> {
    const headers = new HttpHeaders({
      'X-Filter': JSON.stringify(filter),
    });
    return this.http.get<any>(`${this.baseUrl}Admin/staff`, {
      headers,
      observe: 'response',
    });
  }

  createStaffUser(data: any) {
    return this.http.post<any>(`${this.baseUrl}Admin/staff`, data);
  }

  getStaffUser(id: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}Admin/staff/${id}`);
  }

  updateStaffUser(id: string, data: any): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}Admin/staff/${id}`, data);
  }

  deleteStaffUser(id: string): Observable<any> {
    return this.http.delete<any>(`${this.baseUrl}Admin/staff/${id}`);
  }

  syncStaffUsers(): Observable<any> {
    return this.http.post(`${this.baseUrl}Admin/sync-staffs`, {
      responseType: 'text',
    });
  }

  /** Role */
  getRoles(filter: any = {}): Observable<any> {
    const headers = new HttpHeaders({
      'X-Filter': JSON.stringify(filter),
    });
    return this.http.get<any>(`${this.baseUrl}Roles/all`, {
      headers,
      // observe: 'response',
    });
  }

  createRole(data: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}Roles/add`, data);
  }

  updateRole(id: string, data: any): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}Roles/update/${id}`, data);
  }

  removeRole(id: string): Observable<any> {
    return this.http.delete<any>(`${this.baseUrl}Roles/delete/${id}`);
  }

  /** Permissions*/
  getModulePermissions(id: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}Permission/${id}`);
  }

  getAllPermissions(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}Permission`);
  }

  /** role permissions*/
  getRoleAndModuleSpecificPermissions(
    roleId: string,
    module: string,
  ): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}RolePermission/${roleId}/${module}`,
    );
  }

  getAllRolePermissions(roleId: string): Observable<any> {
    return this.http.get(`${this.baseUrl}RolePermission/${roleId}`);
  }

  updateRolePermission(roleId: string, data: any): Observable<any> {
    return this.http.put<any>(
      `${this.baseUrl}RolePermission/update/${roleId}`,
      data,
    );
  }

  syncUsers() {
    return this.http.get(`${this.baseUrl}Auth/sync-users`, {
      responseType: 'text',
    });
  }

  syncRoles() {
    return this.http.get(`${this.baseUrl}Auth/sync-roles`, {
      responseType: 'text',
    });
  }

  // calendar
  getAvailableEvaluators(date: string): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}Admin/available-evaluators/${date}`,
    );
  }

  getAvailableSupervisors(date: string): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}Admin/available-supervisors/${date}`,
    );
  }

  getAvailableAssessors(config: {
    programId: string;
    date: string;
  }): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}Admin/available-assessors/${config.date}/${config.programId}`,
    );
  }

  getAvailableiInspectors(config: {
    programId: string;
    date: string;
  }): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}Admin/available-inspectors/${config.programId}/${config.date}`,
    );
  }
}
